import { createSelector } from 'reselect';
import { RootState } from '../../store';

export const selectUnitProductsUnit = createSelector(
    (state: RootState) => state.unitProducts.unit,
    unit => unit,
);
